import React, { useEffect, useState } from "react";
import {
  Stack,
  Switch,
  Paper,
  Button,
  Snackbar,
  Alert,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  Tooltip,
  Typography,
  IconButton,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@mui/material";
import Select from "react-select";
import Axios from "axios";
import Sidebar from "../sidebar/sidebar";
import { companylogo } from "../../assets/images";
import { BaseUrl } from "../../Environment";
import { getSecureItem, setSecureItem } from "../../utilsFunctions";
// import { generateQR, saveSession, logoutSession } from '../../service/service';
import { getCompanyProfile } from "../../api";
import { LoadingButton } from "@mui/lab";
import DeleteIcon from '@mui/icons-material/Delete';
import BuyCreditsModal from "../ReminderSettings/BuyCreditsModal";
import BuySmsCreditsModal from "../ReminderSettings/BuySmsCreditsModal";
import Holidays from "../Holidays/Holidays";

const Settings = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const loggedinUser = getSecureItem("loggedinUser");
  const currency = getSecureItem("country")?.symbol;
  const [activeWhatsappSession, setActiveWhatsappSession] = useState(false);
  const [companyId] = useState(getSecureItem("loggedinUserCompany"));
  const [qrCode, setQrCode] = useState(null);
  const [qrCodeReGen, setQrCodeReGen] = useState(false);
  const [userType, setUserType] = useState();
  const [userTypes, setUserTypes] = useState([]);
  const [userTypeDetail, setUserTypeDetail] = useState({});
  const [initialUserTypeDetail, setInitialUserTypeDetail] = useState({});
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [isDataChanged2, setIsDataChanged2] = useState(false);
  const [initialLoanSettings, setinitialLoanSettings] = useState({
    autoUpdate: false,
    advanceEMI: false,
    accumulateNP: false,
    autoPenalty: false,
    autoApprove: true,
    autoSms: 0,
    autoPenaltyType: "fixed",
    autoPenaltyValue: "",
    autoPenaltyFrequencyType: "currentDue",
    autoPenaltyFrequency: 0,
    calculationFrequency: "perDay",
  });
  const [loanSettings, setLoanSettings] = useState({
    autoUpdate: false,
    advanceEMI: false,
    accumulateNP: false,
    autoPenalty: false,
    autoApprove: true,
    autoSms: 0,
    autoPenaltyType: "fixed",
    autoPenaltyValue: "",
    autoPenaltyFrequencyType: "currentDue", 
    autoPenaltyFrequency: 0,
    calculationFrequency: "perDay",
  });
  const [settingsId, setSettingsId] = useState("");

  const [whatsappSession, setWhatsappSession] = React.useState(false);

  const [id, setId] = useState(null);
  const [credits, setCredits] = useState(0);
  const [smsCredits, setSmsCredits] = useState(0);
  const [creditsModal, setCreditsModal] = useState(false);
  const [smsCreditsModal, setSmsCreditsModal] = useState(false);
  const [beforeDueDateEnabled, setBeforeDueDateEnabled] = useState(true);
  const [afterDueDateEnabled, setAfterDueDateEnabled] = useState(false);
  const [beforeDueDateOptions, setBeforeDueDateOptions] = useState([5]);
  const [afterDueDateOptions, setAfterDueDateOptions] = useState("Daily");

  const availableBeforeDays = [5, 3, 2, 1];

  const toggleSwitch = (setter) => setter((prev) => !prev);

  const removeBeforeDay = (day) => {
    const updatedDays = beforeDueDateOptions.filter((d) => d !== day);
    setBeforeDueDateOptions(updatedDays.length ? updatedDays : [5]);
  };

  const fetchData = async () => {
    try {
      const companyId = getSecureItem("loggedinUserCompany");
      const token = getSecureItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const resp = await Axios.get(
        `${BaseUrl}/autoReminders/getAutoReminders?companyId=${companyId}`,
        { headers }
      );

      if (resp.status === 200 && resp.data?.status) {
        const { id, afterDueDate, beforeDueDate, beforeDueDays, afterDueFreq, credits, smsCredits } = resp.data.data[0] || {};

        setId(id);
        setAfterDueDateEnabled(afterDueDate);
        setBeforeDueDateEnabled(beforeDueDate);
        setBeforeDueDateOptions(beforeDueDays?.length ? JSON.parse(beforeDueDays) : [5]);
        setAfterDueDateOptions(afterDueFreq || "Daily");
        setCredits(credits || 0);
        setSmsCredits(smsCredits || 0);
      }
    } catch (error) {
      console.error("Error fetching reminders:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const handleOpenWhatsappSession = () => {
  //   handleGenerateQR()
  //   setWhatsappSession(true);
  // };

  const handleCloseWhatsappSession = () => {
    setWhatsappSession(false);
  };

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(
    loggedinUser?.userType === "superAdmin" ? "1" : "2"
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [toastMsg, setToastMsg] = useState({
    msg: "",
    time: 2000,
    variant: "success",
  });

  // Step 1: Initialize state with your array of options mapped to API keys
  const [options, setOptions] = useState([
    { label: "Add Borrowers", key: "addBorrowers", value: false },
    { label: "Edit Borrowers", key: "editBorrowers", value: false },
    { label: "Delete Borrowers", key: "deleteBorrowers", value: false },
    { label: "View Borrowers", key: "viewBorrowers", value: false },
    { label: "Add Loan", key: "addLoan", value: false },
    { label: "Edit / Delete Loan", key: "editLoan", value: false },
    { label: "Edit Collected Date", key: "editCollectedDate", value: false },
    { label: "Add Loan Types", key: "addLoanTypes", value: false },
    { label: "Edit / Delete Loan Types", key: "editLoanTypes", value: false },
    { label: "View Loans", key: "viewLoan", value: false },
    { label: "Approve/Disburse Loan", key: "approveLoan", value: false },
    { label: "Revert Loan Payment", key: "revertPayment", value: false },
    { label: "Payment Collection", key: "receivePayment", value: false },
    { label: "Allow Overpayment", key: "overpaymentLoan", value: false },
    { label: "View Reports", key: "viewReports", value: false },
    { label: "Print Documents", key: "printDocs", value: false },
    { label: "Add Expenses", key: "Expenses", value: false },
    { label: "Edit / Delete Expenses", key: "editExpenses", value: false },
    { label: "Accounting", key: "accounting", value: false },
    { label: "Profit/Loss", key: "profitLoss", value: false },
    { label: "Cash-Flow", key: "cashFlow", value: false },
    { label: "Add User Management", key: "addUsers", value: false },
    { label: "Edit / Delete User Management", key: "editUsers", value: false },
    { label: "Edit Company Profile", key: "editProfile", value: false },
  ]);

  // Step 2: Function to handle the switch toggle
  const handleToggle = (index) => {
    // Update the userTypeDetail with the new value
    if (options[index].key === "viewBorrowers" && options[index].value) {
      setOptions((prevOptions) =>
        prevOptions.map((option, i) =>
          i === index
            ? { ...option, value: !option.value }
            : i === index - 1
            ? { ...option, value: false }
            : option
        )
      );
      setUserTypeDetail((prevDetails) => ({
        ...prevDetails,
        [options[index].key]: !options[index].value, // Toggle the value for the corresponding key
        [options[index - 1].key]: false,
      }));
    } else if (options[index].key === "viewLoan" && options[index].value) {
      setOptions((prevOptions) =>
        prevOptions.map((option, i) =>
          i === index
            ? { ...option, value: !option.value }
            : i === index - 2
            ? { ...option, value: false }
            : option
        )
      );
      setUserTypeDetail((prevDetails) => ({
        ...prevDetails,
        [options[index].key]: !options[index].value, // Toggle the value for the corresponding key
        [options[index - 2].key]: false,
      }));
    } else {
      setOptions((prevOptions) =>
        prevOptions.map((option, i) =>
          i === index ? { ...option, value: !option.value } : option
        )
      );
      setUserTypeDetail((prevDetails) => ({
        ...prevDetails,
        [options[index].key]: !options[index].value, // Toggle the value for the corresponding key
      }));
    }
  };

  const getAllUserTypes = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const result = await Axios.get(
        `${BaseUrl}/userType/getAllUserType?companyId=${loggedinUser.companyId}`,
        {
          headers,
        }
      );

      if (result.data.length > 0) {
        const saData = result?.data?.filter(
          (val) => val?.userType == "superAdmin"
        );
        setUserType(saData[0]?.userTypeId);
        setUserTypes(
          result?.data?.map((item) => ({
            label:
              item?.userType === "superAdmin" ? "Super Admin" : item.userType,
            value: item?.userTypeId,
          }))
        );
      }
    } catch (error) {
      console.log("error: " + JSON.stringify(error));
    }
  };

  const getUserTypeDetails = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const result = await Axios.get(
        `${BaseUrl}/userType/getUserTypeDetails?userTypeId=${userType}&companyId=${loggedinUser?.companyId}&userId=${loggedinUser?.userId}`,
        {
          headers,
        }
      );

      // Update the userTypeDetail state with the data from the API
      setUserTypeDetail(result.data);
      setInitialUserTypeDetail(result.data);

      const saData = userTypes?.filter((val) => val?.label == "Super Admin");

      if (userType == saData[0]?.value) {
        setSecureItem(
          "UsersAccess",
          Object.fromEntries(
            Object.entries(result.data).filter(
              ([key, value]) => typeof value === "boolean"
            )
          )
        );
      }

      // Initialize the switch states based on the API data
      setOptions((prevOptions) =>
        prevOptions.map((option) => ({
          ...option,
          value: result.data[option.key] || false, // Initialize value based on API data
        }))
      );
    } catch (error) {
      console.log("error: " + JSON.stringify(error));
    }
  };

  // Check if any data has changed when the options or userTypeDetail state changes
  useEffect(() => {
    const isChanged =
      JSON.stringify(userTypeDetail) !== JSON.stringify(initialUserTypeDetail);
    setIsDataChanged(isChanged);
  }, [userTypeDetail, initialUserTypeDetail]);

  useEffect(() => {
    if (userType) {
      getUserTypeDetails();
    }
  }, [userType]);

  const updateUserType = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const result = await Axios.put(
        `${BaseUrl}/userType/putUserType`,
        userTypeDetail,
        {
          headers,
        }
      );

      if (result.data?.status) {
        setToastMsg({
          msg: `User Access Updated Successfully`,
          time: 4000,
          variant: "success",
        });

        setTimeout(() => {
          handleOpen();
        }, 500);

        setIsDataChanged(false);
        getUserTypeDetails();
      }
    } catch (error) {
      console.log("error: " + JSON.stringify(error));
    }
  };

  const getAllSettings = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };
      // console.log(loggedinUser);
      const result = await Axios.get(
        `${BaseUrl}/settings/getAllSettings?companyId=${loggedinUser.companyId}&userId=${loggedinUser?.userId}`,
        {
          headers,
        }
      );

      if (result.data) {
        const loanSettings = result.data?.map((val) => ({
          autoUpdate: val?.autoUpdate,
          advanceEMI: val?.advanceEMI,
          accumulateNP: val?.accumulateNP,
          autoPenalty: val?.autoPenalty,
          autoPenaltyType: val?.autoPenaltyType,
          autoPenaltyValue: val?.autoPenaltyValue,
          autoPenaltyFrequency: val?.autoPenaltyFrequency,
          autoApprove: val?.autoApprove,
          autoSms: val?.autoSms,
          settingsId: val?.settingsId,
          customerIdSeries: val?.customerIdSeries || "",
          autoPenaltyFrequencyType: val?.autoPenaltyFrequencyType || "currentDue",
          calculationFrequency: val?.calculationFrequency || "perDay",
        }))[0];
        
        setSecureItem('LoanSettings', loanSettings); 
        
        setLoanSettings({
          autoUpdate: result.data[0]?.autoUpdate,
          advanceEMI: result.data[0]?.advanceEMI,
          accumulateNP: result.data[0]?.accumulateNP,
          autoPenalty: result.data[0]?.autoPenalty,
          autoPenaltyType: result.data[0]?.autoPenaltyType,
          autoPenaltyValue: result.data[0]?.autoPenaltyValue,
          autoPenaltyFrequency: result.data[0]?.autoPenaltyFrequency,
          autoApprove: result.data[0]?.autoApprove,
          autoSms: result.data[0]?.autoSms,
          customerIdSeries: result.data[0]?.customerIdSeries || "",
          autoPenaltyFrequencyType: result.data[0]?.autoPenaltyFrequencyType || "currentDue",
          calculationFrequency: result.data[0]?.calculationFrequency || "perDay",
        });
        setinitialLoanSettings({
          autoUpdate: result.data[0]?.autoUpdate,
          advanceEMI: result.data[0]?.advanceEMI,
          accumulateNP: result.data[0]?.accumulateNP,
          autoPenalty: result.data[0]?.autoPenalty,
          autoPenaltyType: result.data[0]?.autoPenaltyType,
          autoPenaltyValue: result.data[0]?.autoPenaltyValue,
          autoPenaltyFrequency: result.data[0]?.autoPenaltyFrequency,
          autoApprove: result.data[0]?.autoApprove,
          autoSms: result.data[0]?.autoSms,
          customerIdSeries: result.data[0]?.customerIdSeries || "",
          autoPenaltyFrequencyType: result.data[0]?.autoPenaltyFrequencyType || "currentDue",
          calculationFrequency: result.data[0]?.calculationFrequency || "perDay",
        });
        setSettingsId(result.data[0]?.settingsId);
      }
    } catch (error) {
      console.log("error: " + JSON.stringify(error));
    }
  };

  // Fetch Company Data and Update Session
  const fetchCompanyData = async () => {
    try {
      const resp = await getCompanyProfile();
      if (resp) {
        setActiveWhatsappSession(resp.activeWhatsappSession);
      }
    } catch (err) {
      console.error("Error fetching company profile:", err);
    }
  };

  useEffect(() => {
    fetchCompanyData();
    getAllSettings();
    getAllUserTypes();
  }, []);

  useEffect(() => {
    const isChanged =
      JSON.stringify(initialLoanSettings) !== JSON.stringify(loanSettings);
    setIsDataChanged2(isChanged);
  }, [loanSettings, initialLoanSettings]);

  // Handle switch toggle for loan settings
  const handleLoanSettingsToggle = (key) => {
    setLoanSettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
    setIsDataChanged2(true);
  };

  // Update loan settings to the API
  const updateLoanSettings = async () => {
    try {
      if (loanSettings.autoPenalty) {
        if (
          !loanSettings.autoPenaltyType ||
          !loanSettings.autoPenaltyValue ||
          loanSettings.autoPenaltyFrequencyType === null ||
          !loanSettings.calculationFrequency
        ) {
          setToastMsg({
            msg: "Please fill all Auto Penalty fields",
            time: 3000,
            variant: "error",
          });
          handleOpen();
          return;
        }
      }

      if (loanSettings.autoUpdate) {
        if (
          loanSettings.autoPenaltyFrequency === null ||
          loanSettings.autoPenaltyFrequency === undefined
        ) {
          setToastMsg({
            msg: "Please select Auto Penalty Frequency",
            time: 3000,
            variant: "error",
          });
          handleOpen();
          return;
        }
      }

      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const result = await Axios.put(
        `${BaseUrl}/settings/putSettings`,
        {
          settingsId,
          autoUpdate: loanSettings.autoUpdate ? "1" : "0",
          advanceEMI: loanSettings.advanceEMI ? "1" : "0",
          accumulateNP: loanSettings.accumulateNP ? "1" : "0",
          autoPenalty: loanSettings.autoPenalty ? "1" : "0",
          autoPenaltyType: loanSettings.autoPenalty
            ? loanSettings.autoPenaltyType
            : null,
          autoPenaltyValue: loanSettings.autoPenalty
            ? loanSettings.autoPenaltyValue
            : null,
          autoPenaltyFrequencyType: loanSettings.autoPenalty
            ? loanSettings.autoPenaltyFrequencyType
            : null,
          autoPenaltyFrequency:
            loanSettings.autoUpdate
              ? loanSettings.autoPenaltyFrequency
              : null,
          autoApprove: loanSettings.autoApprove ? "1" : "0",
          autoSms: loanSettings.autoSms,
          customerIdSeries: loanSettings.customerIdSeries || null,
          calculationFrequency: loanSettings.calculationFrequency || "perDay",
        },
        { headers }
      );

      if (result.data?.status) {
        setToastMsg({
          msg: `Loan Settings Updated Successfully`,
          time: 4000,
          variant: "success",
        });

        setTimeout(() => handleOpen(), 500);
        setIsDataChanged2(false);
        getAllSettings();
      }
    } catch (error) {
      console.log("error: " + JSON.stringify(error));
    }
  };

  // Generate QR Code
  // const handleGenerateQR = async () => {
  //   try {
  //     setQrCodeReGen(false);

  //     const response = await generateQR(companyId);
  //     if (response?.qr){
  //       setQrCode(response.qr);

  //       setTimeout(() => {
  //         setQrCodeReGen(true)
  //       }, 20000);
  //     };
  //   } catch (err) {
  //     console.error("Error generating QR code:", err);
  //   }
  // };

  // const handleSaveSession = async () => {
  //   const success = await saveSession(companyId);
  //   if (success) {
  //     handleLoanSettingsToggle("autoSms");
  //     fetchCompanyData();
  //     handleCloseWhatsappSession();
  //     // window.location.reload();
  //   };
  // };

  // Auto-save session every 10 seconds if no active session
  // useEffect(() => {
  //   if (qrCode && !activeWhatsappSession) {
  //     const interval = setInterval(() => handleSaveSession(), 5000);
  //     return () => clearInterval(interval);
  //   }
  // }, [activeWhatsappSession, qrCode]);

  // Logout Session
  // const handleLogout = async () => {
  //   try {
  //     const success = await logoutSession(companyId);
  //     console.log("Logout successful:", success);
  //     fetchCompanyData();
  //     if(success){
  //       updateLoanSettings(true);
  //       // window.location.reload();
  //     }
  //   } catch (err) {
  //     console.error("Error logging out:", err);
  //   }
  // };

  const updateReminders = async () => {
    try {
      const companyId = loggedinUser?.companyId;
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const payload = {
        companyId,
        id,
        credits,
        afterDueDate: afterDueDateEnabled,
        beforeDueDate: beforeDueDateEnabled,
        beforeDueDays: beforeDueDateEnabled
          ? JSON.stringify(beforeDueDateOptions)
          : null,
        afterDueFreq: afterDueDateEnabled ? afterDueDateOptions : null,
      };

      const resp = await Axios.put(
        BaseUrl + `/autoReminders/updateAutoReminders`,
        payload,
        {
          headers: headers,
        },
      );

      console.log('response updateReminders: ' + JSON.stringify(resp.data));
      if (resp.data?.status) {
        fetchData();
        setToastMsg({
          msg: resp.data?.msg,
          time: 4000,
          variant: "success",
        });

        setTimeout(() => {
          handleOpen();
        }, 500);
      }
    } catch (error) {
      console.log('error updateReminders', error);
    }
  };

  return (
    <>
      <Sidebar />

      <Snackbar
        open={open}
        autoHideDuration={toastMsg.time}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={toastMsg.variant}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toastMsg.msg}
        </Alert>
      </Snackbar>

      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        padding={"10px 100px"}
      >
        <img src={companylogo} alt="logo" />
      </Stack>

      <Stack
        className="otherincomepage"
        spacing={0}
        padding={"0px 20px 0px 100px"}
      >
        <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
          <Tabs value={value} onChange={handleChange} centered>
            {loggedinUser?.userType === "superAdmin" && (
              <Tab label="Loan Settings" value={"1"} />
            )}
            <Tab label="Access Settings" value={"2"} />
            <Tab label="Setup Auto-Reminder" value={"3"} />
            <Tab label="Setup Holidays" value={"4"} />
          </Tabs>
        </Box>
        {value === "1" ? (
          <Paper
            elevation={3}
            sx={{ p: 2, width: matches ? "85%" : "50%", overflow: "auto" }}
            style={{ margin: "10px auto" }}
          >
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              paddingInline={2}
              mb={2}
            >
              <Stack>
                <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                  Customer Id Series
                </strong>
                <em
                  style={{ fontFamily: "Lato", fontSize: 13, width: "300px" }}
                >
                  (Example: If you enter CU_ST-001(series-counter) , your customers will be assigned IDs like CUST-001, CUST-002 and so on.)
                </em>
              </Stack>
              <TextField
                value={loanSettings.customerIdSeries || ""}
                onChange={(e) => {
                  setLoanSettings((prev) => ({
                    ...prev,
                    customerIdSeries: e.target.value,
                  }));
                }}
                size="small"
              />
            </Stack>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              paddingInline={2}
              mb={2}
              sx={{ borderTop: "1px solid #e0e0e0" }}
            >
              <Stack mt={1}>
                <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                  Automatically Approve and Disburse Loans
                </strong>
                <em
                  style={{ fontFamily: "Lato", fontSize: 13, width: "300px" }}
                >
                  (When enabled, this will automatically change the loan status
                  to disbursed as soon as the loan is created)
                </em>
              </Stack>
              <Switch
                aria-label={"autoApprove"}
                checked={loanSettings.autoApprove}
                onChange={() => handleLoanSettingsToggle("autoApprove")}
              />
            </Stack>
            <Stack
              direction="column"
              paddingInline={2}
              sx={{ borderTop: "1px solid #e0e0e0" }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Tooltip title="Penalty will be calculated automatically when marked as Not Paid" placement="top">
                  <strong style={{ fontFamily: "Lato", fontSize: 15, textDecorationLine: "underline" }}>
                    Calculate Penalty Automatically
                  </strong>
                </Tooltip>
              <Switch
                aria-label={"autoPenalty"}
                checked={loanSettings.autoPenalty}
                onChange={() => handleLoanSettingsToggle("autoPenalty")}
              />
            </Stack>

              {loanSettings.autoPenalty && (
                <Box>
                  <FormControl>
                    <RadioGroup
                      row
                      value={loanSettings.autoPenaltyType}
                      onChange={(e) =>
                        setLoanSettings((prev) => ({
                          ...prev,
                          autoPenaltyType: e.target.value,
                        }))
                      }
                    >
                      <FormControlLabel
                        value="fixed"
                        control={<Radio />}
                        label={`Fixed Amount (${currency})`}
                        sx={{
                          '& .MuiFormControlLabel-label': {
                            fontSize: '13px',
                            fontFamily: 'Lato',
                            whiteSpace: 'nowrap',
                          },
                        }}
                      />
                      <FormControlLabel
                        value="percent"
                        control={<Radio />}
                        label="Percentage (%)"
                        sx={{
                          '& .MuiFormControlLabel-label': {
                            fontSize: '13px',
                            fontFamily: 'Lato',
                            whiteSpace: 'nowrap',
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                  <Box mt={1}>
                    <div>
                      <em style={{ fontFamily: "Lato", fontSize: 13 }}>
                        Calculation Frequency:
                      </em>
                    </div>
                    <FormControl>
                      <RadioGroup
                        row
                        value={loanSettings.calculationFrequency}
                        onChange={(e) =>
                          setLoanSettings((prev) => ({
                            ...prev,
                            calculationFrequency: e.target.value,
                          }))
                        }
                      >
                        <FormControlLabel
                          value="perDay"
                          control={<Radio />}
                          label={
                            loanSettings.autoPenaltyType === "percent"
                              ? "Per day (%)"
                              : `Per day (${currency})`
                          }
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '13px',
                              fontFamily: 'Lato',
                              whiteSpace: 'nowrap',
                            },
                          }}
                        />
                        <FormControlLabel
                          value="oneTime"
                          control={<Radio />}
                          label={
                            loanSettings.autoPenaltyType === "percent"
                              ? "One Time (%)"
                              : `One Time (${currency})`
                          }
                          sx={{
                            '& .MuiFormControlLabel-label': {
                              fontSize: '13px',
                              fontFamily: 'Lato',
                              whiteSpace: 'nowrap',
                            },
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  <TextField
                    type="number"
                    size="small"
                    sx={{ width: "200px" }}
                    label={
                      loanSettings.autoPenaltyType === "fixed"
                        ? "Penalty Amount"
                        : "Penalty Percentage"
                    }
                    value={loanSettings.autoPenaltyValue}
                    onChange={(e) =>
                      setLoanSettings((prev) => ({
                        ...prev,
                        autoPenaltyValue: e.target.value,
                      }))
                    }
                    inputProps={{ min: 0 }}
                  />
                  <Box>
                    <div>
                    <em style={{ fontFamily: "Lato", fontSize: 13 }}>
                      Calculate penalty on:
                    </em>
                    </div>
                    <FormControl>
                      <RadioGroup
                        value={loanSettings.autoPenaltyFrequencyType}
                        onChange={(e) =>
                          setLoanSettings((prev) => ({
                            ...prev,
                            autoPenaltyFrequencyType: e.target.value,
                          }))
                        }
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <Tooltip title="Penalty calculated only on the current due amount" placement="top">
                          <FormControlLabel
                            value="currentDue"
                            control={<Radio />}
                            label="Due Amount"
                            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', fontFamily: 'Lato' } }}
                          />
                        </Tooltip>
                        <Tooltip title="Penalty calculated on the Outstanding Balance Amount" placement="top">
                          <FormControlLabel
                            value="totalPending"
                            control={<Radio />}
                            label="OutstandingBalance Amount"
                            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', fontFamily: 'Lato' } }}
                          />
                        </Tooltip>
                        <Tooltip title={`Penalty calculated on the amount left from the due amount (if customer paid ${currency}300 of ${currency}1000 due, penalty will be on ${currency}700)`} placement="top">
                          <FormControlLabel
                            value="currentCollected"
                            control={<Radio />}
                            label="(Due-Collected) Amount"
                            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', fontFamily: 'Lato' } }}
                          />
                        </Tooltip>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
              )}
            </Stack>
              <div>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  paddingInline={2}
                  mb={2}
                  sx={{ borderTop: "1px solid #e0e0e0" }}
                >
                  <Stack mt={1}>
                    <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                      Auto-update loans at your chosen frequency
                    </strong>
                    <em
                      style={{ fontFamily: "Lato", fontSize: 13, width: "300px" }}
                    >
                      (Any loan not updated within this timeframe will be
                      auto-marked as Not Paid.)
                    </em>
                  </Stack>
                  <Switch
                    aria-label={"autoUpdate"}
                    checked={loanSettings.autoUpdate}
                    onChange={() => handleLoanSettingsToggle("autoUpdate")}
                  />
                </Stack>
                {loanSettings.autoUpdate && (
                  <Stack
                    direction="row"
                    spacing={3}
                    ml={2}
                    mt={1}
                    mb={2}
                    alignItems="flex-end"
                  >
                    <FormControl size="small" sx={{ width: 200 }}>
                      <FormLabel sx={{ fontSize: 13, mb: 1 }}>
                        Auto Penalty Frequency
                      </FormLabel>
                      <Select
                        value={{
                          label:
                            loanSettings.autoPenaltyFrequency === 0
                              ? "0 days"
                              : `${loanSettings.autoPenaltyFrequency} day(s)`,
                          value: loanSettings.autoPenaltyFrequency,
                        }}
                        options={[0, 1, 2, 5, 7].map((d) => ({
                          label: d === 0 ? "0 days" : `${d} day${d > 1 ? "s" : ""}`,
                          value: d,
                        }))}
                        onChange={(val) =>
                          setLoanSettings((prev) => ({
                            ...prev,
                            autoPenaltyFrequency: val.value,
                          }))
                        }
                      />
                    </FormControl>
                  </Stack>
                )}
              </div>
            <Stack
              direction="column"
              paddingInline={2}
              mb={2}
              sx={{ borderTop: "1px solid #e0e0e0" }}
            >
              <Stack mt={1}>
                <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                  Auto send transaction messages via WhatsApp/SMS
                </strong>
                <em
                  style={{ fontFamily: "Lato", fontSize: 13, width: "300px" }}
                >
                  (Based on this selection, reminders and receipts will be sent via SMS, WhatsApp, or both.)
                </em>
              </Stack>
              <Box>
                <FormControl component="fieldset" style={{ border: "none" }}>
                  <RadioGroup
                    row
                    value={loanSettings.autoSms}
                    onChange={(e) => {
                      setLoanSettings((prev) => ({
                        ...prev,
                        autoSms: parseInt(e.target.value),
                      }));
                      setIsDataChanged2(true);
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio />}
                      label="Disabled"
                      sx={{
                          '& .MuiFormControlLabel-label': {
                            fontSize: '13px',
                            fontFamily: 'Lato',
                            whiteSpace: 'nowrap',
                          },
                        }}
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="SMS"
                      disabled={currency !== "INR"}
                      sx={{
                          '& .MuiFormControlLabel-label': {
                            fontSize: '13px',
                            fontFamily: 'Lato',
                            whiteSpace: 'nowrap',
                          },
                        }}
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label="WhatsApp"
                      sx={{
                          '& .MuiFormControlLabel-label': {
                            fontSize: '13px',
                            fontFamily: 'Lato',
                            whiteSpace: 'nowrap',
                          },
                        }}
                    />
                    <FormControlLabel
                      value={3}
                      control={<Radio />}
                      label="Both (SMS and WhatsApp)"
                      disabled={currency !== "INR"}
                      sx={{
                          '& .MuiFormControlLabel-label': {
                            fontSize: '13px',
                            fontFamily: 'Lato',
                            whiteSpace: 'nowrap',
                          },
                        }}
                    />
                  </RadioGroup>
                  {currency !== "INR" && (
                    <em style={{ fontFamily: "Lato", fontSize: 12, color: "gray" }}>
                      SMS and Both options are available only in India.
                    </em>
                  )}
                </FormControl>
              </Box>
            </Stack>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              paddingInline={2}
              mb={2}
              sx={{ borderTop: "1px solid #e0e0e0" }}
            >
              <Stack>
                <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                  Overpayment Handling
                </strong>
                <em
                  style={{ fontFamily: "Lato", fontSize: 13, width: "300px" }}
                >
                  (Based on this, Default option will be shown in the Receive Payment Screen)
                </em>
              </Stack>
              <Stack>
                <FormControl component="fieldset" style={{ border: "none" }}>
                  <RadioGroup
                    aria-label="position"
                    name="position"
                    value={loanSettings.advanceEMI}
                    onChange={() => handleLoanSettingsToggle("advanceEMI")}
                  >
                    <Tooltip title="Any extra amount paid will be recorded as Advance EMI and adjusted against future installments." placement="top"><FormControlLabel
                      value={true}
                      control={<Radio size="small" style={{ color: "#4d66f0" }} />}
                      label={<Typography className="Fonts" fontSize={14}>Advance EMI</Typography>}
                      labelPlacement="start"
                    /></Tooltip>
                    <Tooltip title="Any extra amount paid will be used to shorten the loan tenure by settling future installments early." placement="top"><FormControlLabel
                      value={false}
                      control={<Radio size="small" style={{ color: "#4d66f0" }} />}
                      label={<Typography className="Fonts" fontSize={14}>Reduce Tenure</Typography>}
                      labelPlacement="start"
                    /></Tooltip>
                  </RadioGroup>
                </FormControl>
              </Stack>
            </Stack>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              paddingInline={2}
              mb={2}
              sx={{ borderTop: "1px solid #e0e0e0" }}
            >
              <Stack>
                <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                  When installment is not paid
                </strong>
                <em
                  style={{ fontFamily: "Lato", fontSize: 13, width: "300px" }}
                >
                  (Based on this, Default option will be shown in the Not-Paid Screen)
                </em>
              </Stack>
              <Stack>
                <FormControl component="fieldset" style={{ border: "none" }}>
                  <RadioGroup
                    aria-label="position"
                    name="position"
                    value={loanSettings.accumulateNP}
                    onChange={() => handleLoanSettingsToggle("accumulateNP")}
                  >
                    <Tooltip title="The unpaid amount will be added to the next installment." placement="top"><FormControlLabel
                      value={true}
                      control={<Radio size="small" style={{ color: "#4d66f0" }} />}
                      label={<Typography className="Fonts" fontSize={14}>Accumulate in Outstanding</Typography>}
                      labelPlacement="start"
                    /></Tooltip>
                    <Tooltip title="The unpaid EMI will be moved to the next due date and the schedule will be extended." placement="top"><FormControlLabel
                      value={false}
                      control={<Radio size="small" style={{ color: "#4d66f0" }} />}
                      label={<Typography className="Fonts" fontSize={14}>Increase Loan Tenure</Typography>}
                      labelPlacement="start"
                    /></Tooltip>
                  </RadioGroup>
                </FormControl>
              </Stack>
            </Stack>
            {/* <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              paddingInline={2}
            >
              <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
              Auto-send transaction messages via WhatsApp login.{" "}
                <button style={{backgroundColor: activeWhatsappSession ? "#fc4040" : "#4d66f0", color: "white", fontWeight: "bold", fontFamily: "Lato", padding: "3px 15px 5px 15px", margin: 5, borderRadius: 50, borderColor: "transparent", cursor: "pointer"}} onClick={activeWhatsappSession ? handleLogout : handleOpenWhatsappSession }>
                  {activeWhatsappSession ? "Logout" : "Login"}
                </button>
              </strong>
              <Switch
                aria-label={"autoSms"}
                checked={loanSettings.autoSms}
                onChange={() => activeWhatsappSession ? handleLoanSettingsToggle("autoSms") : handleOpenWhatsappSession()}
              />
            </Stack> */}
          </Paper>
        ) : value === "2" ? (
          <Paper
            elevation={3}
            sx={{ p: 2, width: matches ? "85%" : "50%", overflow: "auto" }}
            style={{ margin: "10px auto" }}
          >
            <div
              style={{
                marginBottom: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Stack spacing={0.5}>
                <strong style={{ fontFamily: "Lato", fontSize: 14 }}>
                  Choose User Type
                </strong>
                <Select
                  options={userTypes}
                  placeholder="Select User's Type"
                  value={userTypes?.find((item) => item.value === userType)}
                  onChange={(val) => setUserType(val?.value)}
                  styles={{
                    container: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "250px",
                      fontFamily: "Lato",
                    }),
                  }}
                />
              </Stack>
            </div>
            {options?.map((data, index) => (
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                paddingInline={2}
                key={index}
              >
                <strong style={{ fontFamily: "Lato", fontSize: 15 }}>
                  {data?.label}
                </strong>
                <Switch
                  aria-label={data?.label}
                  checked={data?.value}
                  onChange={() => handleToggle(index)}
                  disabled={
                    // Disable "addBorrowers" if "viewBorrowers" is false
                    (data.key === "addBorrowers" &&
                      !options.find((o) => o.key === "viewBorrowers").value) ||
                    // Disable "addLoan" if "viewLoan" is false
                    (data.key === "addLoan" &&
                      !options.find((o) => o.key === "viewLoan").value)
                  }
                />
              </Stack>
            ))}
          </Paper>
        ) : value === "3" ? (
          <Paper
            elevation={3}
            sx={{ p: 2, width: matches ? "85%" : "50%", overflow: "auto" }}
            style={{ margin: "10px auto" }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
              <Typography>WhatsApp Credits: {credits} left</Typography>
              <Button variant="contained" color="success" onClick={() => setCreditsModal(true)}>
                Buy More
              </Button>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
              <Typography>SMS Credits: {smsCredits} left</Typography>
              <Button variant="contained" color="success" onClick={() => setSmsCreditsModal(true)}>
                Buy More
              </Button>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
              <Typography>After Due Date</Typography>
              <Switch checked={afterDueDateEnabled} onChange={() => toggleSwitch(setAfterDueDateEnabled)} />
            </Box>
            {afterDueDateEnabled && (
              <Select
                options={[{label: "Daily", value: "Daily"}, {label: "Weekly", value: "Weekly"}]}
                value={[{label: "Daily", value: "Daily"}, {label: "Weekly", value: "Weekly"}].find((item) => item.value == afterDueDateOptions)}
                onChange={(val) => setAfterDueDateOptions(val?.value)}
              />
            )}
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
              <Typography>Before Due Date</Typography>
              <Switch checked={beforeDueDateEnabled} onChange={() => toggleSwitch(setBeforeDueDateEnabled)} />
            </Box>
            {beforeDueDateEnabled && (
              <Box mt={2}>
                {beforeDueDateOptions.map(day => (
                  <Box key={day} display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{ backgroundColor: '#e0e0e0', borderRadius: 1, mb: 1 }}>
                    <Typography>{day} {day === 1 ? "day" : "days"}</Typography>
                    <IconButton onClick={() => removeBeforeDay(day)} size="small" color="error">
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ))}
                {availableBeforeDays.filter(day => !beforeDueDateOptions.includes(day))?.length != 0 && <Select
                  options={availableBeforeDays.filter(day => !beforeDueDateOptions.includes(day)).map(day => (
                    {value: day, label: `${day} ${day === 1 ? "day" : "days"}`}
                  ))}
                  onChange={val => setBeforeDueDateOptions([...beforeDueDateOptions, val.value])}
                />}
              </Box>
            )}
            <BuyCreditsModal open={creditsModal} onClose={() => setCreditsModal(false)} onSubmit={(link) => window.open(link, "_blank")} />
            <BuySmsCreditsModal open={smsCreditsModal} onClose={() => setSmsCreditsModal(false)} onSubmit={(link) => window.open(link, "_blank")} />
          </Paper>
        ) : (
          <Holidays />
        )}
        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          style={{ margin: "10px auto", width: matches ? "85%" : "50%" }}
        >
          {value === "1" ? (
            <Button
              className="GreenBTN"
              style={{ width: "100px" }}
              variant="filled"
              onClick={() => updateLoanSettings(false)}
              disabled={!isDataChanged2}
            >
              Save
            </Button>
          ) : value === "2" ? (
            <Button
              className="GreenBTN"
              style={{ width: "100px" }}
              variant="filled"
              onClick={updateUserType}
              disabled={!isDataChanged}
            >
              Save
            </Button>
          ) : value === "3" ? (
            <Button
              className="GreenBTN"
              style={{ width: "100px" }}
              variant="filled"
              onClick={updateReminders}
            >
              Save
            </Button>
          ) : (
            null
          )}
        </Stack>
      </Stack>
      <Dialog
        open={whatsappSession}
        onClose={handleCloseWhatsappSession}
        aria-labelledby="alert-dialog-title-support"
        aria-describedby="alert-dialog-description-support"
      >
        <DialogTitle textAlign={"center"}>How To Proceed</DialogTitle>
        <Stack
          sx={{ padding: 2 }}
          spacing={1}
          direction={"row"}
        >
          <ol style={{padding: 0, margin: "0px 20px"}}>
            <li>Open WhatsApp on your phone</li>
            <li>Tap Menu (⋮) or Settings (⚙️) and go to Linked Devices</li>
            <li>Tap on Link a Device</li>
            <li>Point your phone at this QR code to scan and link</li>
            <li>Please stay on this page until you have successfully logged in</li>
          </ol>
          <Divider orientation="vertical" flexItem sx={{ mx: 2}} />
        </Stack>
        {/* {qrCodeReGen && <DialogActions><Button onClick={handleGenerateQR}>Regenerate QR Code</Button></DialogActions>} */}
      </Dialog>
    </>
  );
};

export default Settings;
